"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentsBillingProfiles = PaymentsBillingProfiles;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const react_styled_1 = require("styled-breakpoints/react-styled");
const styled_components_1 = __importStar(require("styled-components"));
const elements_1 = require("@src/components/elements");
const Api = __importStar(require("@src/api"));
const styled_breakpoints_1 = require("styled-breakpoints");
const react_intl_1 = require("react-intl");
const BillingProfilesTable = (0, styled_components_1.default)(elements_1.Table) `
	${props => props.onRow &&
    (0, styled_components_1.css) `
			tbody tr:hover {
				cursor: pointer;
			}
			.buttons-table-cell {
				cursor: default;
			}
		`}
`;
function PaymentsBillingProfiles() {
    const intl = (0, react_intl_1.useIntl)();
    const isXsLayout = (0, react_styled_1.useBreakpoint)((0, styled_breakpoints_1.only)('xs'));
    const [billingProfiles, setBillingProfiles] = react_1.default.useState([]);
    const [selectedDefaultProfile, setSelectedDefaultProfile] = react_1.default.useState(0);
    const formatAddress = addressParts => {
        const address = addressParts.filter(Boolean).join(', ');
        return address;
    };
    const billingProfilesTableSource = billingProfiles.map(profile => {
        if (!selectedDefaultProfile && profile.isDefault && profile.id) {
            setSelectedDefaultProfile(profile.id);
        }
        const billingProfileTableRow = {
            key: profile.id,
            id: profile.id,
            name: profile.name,
            address: formatAddress([profile.street, profile.city, profile.postalCode]),
            isDefault: Boolean(profile.isDefault),
            offersCount: profile.offers.length || 0,
        };
        return billingProfileTableRow;
    });
    const getAllCompanyBillingProfiles = async () => {
        try {
            const { allBillingProfilesById } = await Api.CompanyBillingProfile.getBillingProfiles();
            setBillingProfiles(allBillingProfilesById);
        }
        catch (err) {
            antd_1.notification.error({
                message: intl.formatMessage({
                    id: 'global.notification_variants.error',
                }),
                description: intl.formatMessage({
                    id: 'global.notification_variants.something_went_wrong',
                }),
            });
            console.error(err);
        }
    };
    const setCompanyDefaultProfile = async (billingProfileId) => {
        try {
            await Api.CompanyBillingProfile.setDefaultBillingProfile(billingProfileId);
            antd_1.notification.success({
                message: intl.formatMessage({
                    id: 'admin.payments.billing_profile_changed_default',
                }),
                placement: 'bottomRight',
            });
        }
        catch (err) {
            antd_1.notification.error({
                message: intl.formatMessage({
                    id: 'global.notification_variants.error',
                }),
                description: intl.formatMessage({
                    id: 'global.notification_variants.something_went_wrong',
                }),
            });
            console.error(err);
        }
    };
    const deleteBillingProfile = async (billingProfileId) => {
        try {
            await Api.CompanyBillingProfile.deleteBillingProfile(billingProfileId);
            getAllCompanyBillingProfiles();
            antd_1.notification.success({
                message: intl.formatMessage({
                    id: 'admin.payments.billing_profile_deleted',
                }),
                placement: 'bottomRight',
            });
        }
        catch (err) {
            antd_1.notification.error({
                message: intl.formatMessage({ id: 'general.error' }),
                description: intl.formatMessage({ id: 'general.something_went_wrong' }),
            });
            console.error(err);
        }
    };
    react_1.default.useEffect(() => {
        getAllCompanyBillingProfiles();
    }, []);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(BillingProfilesTable, { pagination: false, scroll: isXsLayout ? { x: 500 } : undefined, dataSource: billingProfilesTableSource, onRow: (record) => {
                    return {
                        onClick: () => {
                            if (record.id && record.id !== selectedDefaultProfile) {
                                setCompanyDefaultProfile(record.id);
                                setSelectedDefaultProfile(record.id);
                            }
                        },
                    };
                }, columns: [
                    {
                        key: 'defaultRadioButtons',
                        title: intl.formatMessage({
                            id: 'admin.payments.default_profile',
                        }),
                        render: (billingData) => ((0, jsx_runtime_1.jsx)("div", { className: "text-center", children: (0, jsx_runtime_1.jsx)(antd_1.Radio, { value: billingData.id, checked: billingData.id === selectedDefaultProfile }) }, billingData.id)),
                    },
                    {
                        title: intl.formatMessage({
                            id: 'admin.payments.company_name',
                        }),
                        dataIndex: 'name',
                        key: 'name',
                    },
                    {
                        title: intl.formatMessage({
                            id: 'admin.payments.billing_address',
                        }),
                        dataIndex: 'address',
                        key: 'address',
                    },
                    {
                        key: 'buttons',
                        align: 'right',
                        className: 'buttons-table-cell',
                        onCell: () => ({
                            onClick: event => {
                                event.stopPropagation();
                            },
                        }),
                        render: (billingData) => ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(elements_1.Link, { to: `/admin/platby/fakturacny-profil/${billingData.id}`, children: (0, jsx_runtime_1.jsx)(elements_1.Button, { size: "small", type: "default", className: "m-xs", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "general.edit" }) }) }), billingData.id !== selectedDefaultProfile && billingData.offersCount === 0 && ((0, jsx_runtime_1.jsx)(antd_1.Popconfirm, { title: intl.formatMessage({
                                        id: 'admin.payments.payment_methods.are_you_sure_remove_billing_profile',
                                    }), okText: intl.formatMessage({
                                        id: 'general.yes',
                                    }), cancelText: intl.formatMessage({
                                        id: 'general.no',
                                    }), onConfirm: () => {
                                        deleteBillingProfile(billingData.id);
                                    }, children: (0, jsx_runtime_1.jsx)(elements_1.Button, { size: "small", type: "default", danger: true, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "general.delete" }) }) }))] }, billingData.id)),
                    },
                ] }), (0, jsx_runtime_1.jsx)("div", { className: "text-center", children: (0, jsx_runtime_1.jsx)(elements_1.Link, { to: "/admin/platby/fakturacny-profil", children: (0, jsx_runtime_1.jsx)(elements_1.Button, { type: "primary", size: "middle", className: "m-t-s m-b-s ", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "general.create_new" }) }) }) })] }));
}
